var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkylineLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 662,
    height: 372,
    viewBox: "0 0 662 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.5,
    y: 163.5,
    width: 62,
    height: 210,
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.102 165H551V170V372H558.102V170H610V165H558.102Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 239.5,
    width: 68,
    height: 134,
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 220.5,
    width: 42,
    height: 19,
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.5 210.5H552.5V373.5H477.5V210.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.5,
    y: 210.5,
    width: 24,
    height: 163,
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462 212H455V218V291H462V218H476V212H462Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 479,
    y: 212,
    width: 72,
    height: 6,
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.5 196.655V210.5H472.5V196.655C472.829 196.554 473.238 196.433 473.725 196.296C475.209 195.878 477.414 195.317 480.264 194.754C485.963 193.629 494.241 192.5 504.5 192.5C514.759 192.5 523.037 193.629 528.736 194.754C531.586 195.317 533.791 195.878 535.275 196.296C535.762 196.433 536.171 196.554 536.5 196.655Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 11.2374,
    height: 10,
    transform: "matrix(1 0 0 -1 558.779 162)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 62,
    height: 20,
    transform: "matrix(1 0 0 -1 597 212)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 11.2374,
    height: 10,
    transform: "matrix(1 0 0 -1 569.458 162)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5 46.5H194.5V373.5H128.5V46.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 14.5,
    width: 58,
    height: 17,
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 4.5,
    width: 43,
    height: 27,
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5,
    y: 46.5,
    width: 48.017,
    height: 327,
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 130,
    y: 48,
    width: 8,
    height: 209,
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196 0H179V30H91V48H196V31V30V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196 0H179V30H91V48H196V31V30V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 0V-3H176V0H179ZM196 0H199V-3H196V0ZM179 30V33H182V30H179ZM91 30V27H88V30H91ZM91 48H88V51H91V48ZM196 48V51H199V48H196ZM179 3H196V-3H179V3ZM182 30V0H176V30H182ZM179 27H91V33H179V27ZM88 30V48H94V30H88ZM91 51H196V45H91V51ZM199 48V31H193V48H199ZM199 31V30H193V31H199ZM193 0V30H199V0H193Z",
    fill: "#0485BA",
    mask: "url(#path-18-inside-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.5,
    y: 38.5,
    width: 44,
    height: 335,
    fill: "white",
    stroke: "#00639C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.5,
    y: 38.5,
    width: 62,
    height: 335,
    fill: "white",
    stroke: "#00639C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 325,
    y: 40,
    width: 14,
    height: 65,
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M387 40H395.305V246H387V40Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.966 5H380.451V18.1488L336.966 22.0513V40H406.966V15.7692L406.966 15.7692V5Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.966 5H380.451V18.1488L336.966 22.0513V40H406.966V15.7692L406.966 15.7692V5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.451 5V2H377.451V5H380.451ZM406.966 5H409.966V2H406.966V5ZM380.451 18.1488L380.719 21.1368L383.451 20.8916V18.1488H380.451ZM336.966 22.0513L336.698 19.0633L333.966 19.3085V22.0513H336.966ZM336.966 40H333.966V43H336.966V40ZM406.966 40V43H409.966V40H406.966ZM406.966 15.7692H409.966V12.4748L406.686 12.7823L406.966 15.7692ZM406.966 15.7692H403.966V19.0636L407.246 18.7561L406.966 15.7692ZM380.451 8H406.966V2H380.451V8ZM383.451 18.1488V5H377.451V18.1488H383.451ZM380.182 15.1608L336.698 19.0633L337.234 25.0393L380.719 21.1368L380.182 15.1608ZM333.966 22.0513V40H339.966V22.0513H333.966ZM336.966 43H406.966V37H336.966V43ZM409.966 40V15.7692H403.966V40H409.966ZM406.686 12.7823L406.686 12.7823L407.246 18.7561L407.246 18.7561L406.686 12.7823ZM403.966 5V15.7692H409.966V5H403.966Z",
    fill: "#00639C",
    mask: "url(#path-24-inside-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.5,
    y: 125.5,
    width: 62,
    height: 248,
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 62,
    height: 19,
    transform: "matrix(1 0 0 -1 279 124)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341 127H282V129.703V138V372.703H295V138H341V127Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.5,
    y: 179.5,
    width: 62,
    height: 194,
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.5 247.5H408.5V258.5H369.5V247.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.5,
    y: 247.5,
    width: 19,
    height: 11,
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5 258.5H436.5V281.5H342.5V258.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5 258.5H366.582L370.242 281.5H343.5V258.5Z",
    fill: "#9BCEE3",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5 281.5H451.869L523.92 373.5H342.5V281.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5 281.5H385.819L439.391 373.5H343.5V281.5Z",
    fill: "#9BCEE3",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.5508,
    y: 258.5,
    width: 97.8474,
    height: 23,
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 82,
    y: 48,
    width: 8,
    height: 244,
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.5,
    y: 213.5,
    width: 62,
    height: 160,
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659 195H600V195.895V197.684V212H605.393V197.684H659V195Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.5508,
    y: 258.5,
    width: 31.4068,
    height: 23,
    fill: "#9BCEE3",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.399883,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289 181H230V183V186V313L236 324V186H289V181Z",
    fill: "#2CA0AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 308.5H359.589L400.291 373.5H173.5V308.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 281.5H219.795L269.485 373.5H56.5V281.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 281.5H92.5956L150.289 373.5H54.5V281.5Z",
    fill: "#9BCEE3",
    stroke: "#0485BA",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 662,
    height: 372,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkylineLeft);
export default __webpack_public_path__ + "static/media/skyline-left.46fcad343c716a09d360d9db1c7009ff.svg";
export { ForwardRef as ReactComponent };